"use strict";
/*
Created by Ioannis Sofos
gs.sofos@gmail.com
*/
Object.defineProperty(exports, "__esModule", { value: true });
class MGRS {
    constructor() {
        this.kan = new Array();
        this.lkan = new Array();
        this.lkanPut = false;
        this.kan = new Array();
        this.kanN = 0;
        this.kanPut = false;
        this.lkan = new Array();
        this.lkanPut = false;
        this.ED_a = 6378388.0;
        this.ED_f = 1 / 297.00000564939;
        this.ED_e = Math.sqrt(2 * this.ED_f - this.ED_f * this.ED_f);
        this.ED_b = 6356911.946;
        this.wgs84_a = 6378137;
        this.wgs84_f = 1 / 298.257223563;
        this.wgs84_e = Math.sqrt(2 * this.wgs84_f - this.wgs84_f * this.wgs84_f);
        var wgs84_b = 6356752.314;
    }
    rad(x) { return x * Math.PI / 180; }
    dist00(p1, p2) {
        const R = 6371000; // earth's mean radius in km
        const dLat = this.rad(p2.lat() - p1.lat());
        const dLong = this.rad(p2.lng() - p1.lng());
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.rad(p1.lat())) * Math.cos(this.rad(p2.lat())) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d;
    }
    flh2xyz(f, l, h = 0, Ell = "WGS84") {
        const pi = Math.PI;
        let a = 0;
        let e = 0;
        if (Ell === "WGS84") {
            a = this.wgs84_a;
            e = this.wgs84_e;
        }
        if (Ell === "ED50") {
            a = this.ED_a;
            e = this.ED_e;
        }
        var par = Math.sqrt(1 - (e * e * Math.sin(f * pi / 180) * Math.sin(f * pi / 180)));
        var n = a / (Math.sqrt(1 - (e * e * Math.sin(f * pi / 180) * Math.sin(f * pi / 180))));
        var x = (n + h) * Math.cos(f * pi / 180) * Math.cos(l * pi / 180);
        var y = (n + h) * Math.cos(f * pi / 180) * Math.sin(l * pi / 180);
        var z = (n * (1 - e * e) + h) * Math.sin(f * pi / 180);
        var out = new Array();
        out[0] = x;
        out[1] = y;
        out[2] = z;
        return out;
    }
    xyz2flh(x, y, z, Ell = "WGS84") {
        const pi = Math.PI;
        let a = 0;
        let e = 0;
        let ff = 0;
        if (Ell === "WGS84") {
            a = this.wgs84_a;
            e = this.wgs84_e;
            ff = this.wgs84_f;
        }
        if (Ell === "ED50") {
            a = this.ED_a;
            e = this.ED_e;
            ff = this.ED_f;
        }
        const l = Math.atan(y / x);
        const ge = e * e / (1 - e * e);
        const gb = a * (1 - ff);
        const gp = Math.sqrt(x * x + y * y);
        const gq = Math.atan((z * a) / (gp * gb));
        const f = Math.atan((z + ge * gb * Math.sin(gq) * Math.sin(gq) * Math.sin(gq)) / (gp - e * e * a * Math.cos(gq) * Math.cos(gq) * Math.cos(gq)));
        const h = (gp / Math.cos(f)) - a / Math.sqrt(1 - (e * e * Math.sin(f) * Math.sin(f)));
        let out = [f * 180 / pi,
            l * 180 / pi,
            h];
        return out;
    }
    fled50towgs84(f, l, h = 0) {
        const xyz = this.flh2xyz(f, l, h, "ED50");
        const ED_x = xyz[0];
        const ED_y = xyz[1];
        const ED_z = xyz[2];
        const dx = -84.0;
        const dy = -95.0;
        const dz = -130.0;
        const W_x = ED_x + dx;
        const W_y = ED_y + dy;
        const W_z = ED_z + dz;
        const out = this.xyz2flh(W_x, W_y, W_z, "WGS84");
        return out;
    }
    flwgs84toed50(f, l, h = 0) {
        const xyz = this.flh2xyz(f, l, h, "WGS84");
        const W_x = xyz[0];
        const W_y = xyz[1];
        const W_z = xyz[2];
        const dx = 84.0;
        const dy = 95.0;
        const dz = 130.0;
        const ED_x = W_x + dx;
        const ED_y = W_y + dy;
        const ED_z = W_z + dz;
        return this.xyz2flh(ED_x, ED_y, ED_z, "ED50");
    }
    fl2EDMGRS(f1, l1) {
        const pi = Math.PI;
        let f = f1;
        let l = l1;
        const lt = l + 180;
        const GridZoneL = Math.floor(lt / 6) + 1;
        let GridZoneF;
        let ft = f + 80;
        ft = Math.floor(ft / 8) + 1;
        switch (ft) {
            case 1:
                GridZoneF = 'C';
                break;
            case 2:
                GridZoneF = 'D';
                break;
            case 3:
                GridZoneF = 'E';
                break;
            case 4:
                GridZoneF = 'F';
                break;
            case 5:
                GridZoneF = 'G';
                break;
            case 6:
                GridZoneF = 'H';
                break;
            case 7:
                GridZoneF = 'J';
                break;
            case 8:
                GridZoneF = 'K';
                break;
            case 9:
                GridZoneF = 'L';
                break;
            case 10:
                GridZoneF = 'M';
                break;
            case 11:
                GridZoneF = 'N';
                break;
            case 12:
                GridZoneF = 'P';
                break;
            case 13:
                GridZoneF = 'Q';
                break;
            case 14:
                GridZoneF = 'R';
                break;
            case 15:
                GridZoneF = 'S';
                break;
            case 16:
                GridZoneF = 'T';
                break;
            case 17:
                GridZoneF = 'U';
                break;
            case 18:
                GridZoneF = 'V';
                break;
            case 19:
                GridZoneF = 'W';
                break;
            case 20:
                GridZoneF = 'X';
                break;
            case 21:
                ft = 20;
                GridZoneF = 'C';
                break;
        }
        const GridZone = GridZoneL + GridZoneF;
        let Fo = 0;
        let Lo = GridZoneL * 6 - 3;
        const w = 6;
        Lo = Lo - 180;
        const k0 = 0.9996;
        Fo = Fo * pi / 180;
        Lo = Lo * pi / 180;
        f = f * pi / 180;
        l = l * pi / 180;
        const e = this.ED_e;
        const a = this.ED_a;
        const pT = Math.tan(f) * Math.tan(f);
        const pC = (Math.pow(e, 2)) * (Math.pow(Math.cos(f), 2)) / (1 - Math.pow(e, 2));
        const pA = (l - Lo) * Math.cos(f);
        const pn = a / Math.sqrt(1 - (e * e) * (Math.sin(f) * Math.sin(f)));
        let pM = (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256) * f;
        pM = pM - (3 * Math.pow(e, 2) / 8 + 3 * Math.pow(e, 4) / 32 + 45 * Math.pow(e, 6) / 1024) * Math.sin(2 * f);
        pM = pM + (15 * Math.pow(e, 4) / 256 + 45 * Math.pow(e, 6) / 1024) * Math.sin(4 * f);
        pM = pM - (35 * Math.pow(e, 6) / 3072) * Math.sin(6 * f);
        pM = pM * a;
        let pM0 = (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256) * Fo;
        pM0 = pM0 - (3 * Math.pow(e, 2) / 8 + 3 * Math.pow(e, 4) / 32 + 45 * Math.pow(e, 6) / 1024) * Math.sin(2 * Fo);
        pM0 = pM0 + (15 * Math.pow(e, 4) / 256 + 45 * Math.pow(e, 6) / 1024) * Math.sin(4 * Fo);
        pM0 = pM0 - (35 * Math.pow(e, 6) / 3072) * Math.sin(6 * Fo);
        pM0 = pM0 * a;
        const et = Math.sqrt(e * e / (1 - e * e));
        //Compute UTM X
        //Ypolohismos UTM X
        const XX = 500000 + k0 * pn * (pA + (1 - pT + pC) * pA * pA * pA / 6 + (5 - 18 * pT + pT * pT + 72 * pC - 58 * et * et) * pA * pA * pA * pA * pA / 120);
        //Compute UTM Y
        //Ypolohismos UTM Y
        let YY = pA * pA / 2;
        YY = YY + (5 - pT + 9 * pC + 4 * pC * pC) * pA * pA * pA * pA / 24;
        YY = YY + (61 - 58 * pT + pT * pT + 600 * pC - 330 * et * et) * Math.pow(pA, 6) / 720;
        YY = YY * pn * Math.tan(f);
        YY = YY + pM - pM0;
        YY = YY * k0;
        YY = YY;
        //Y offset for South Hemisphere
        if (f < 0) {
            YY = YY + 10000000;
        }
        const z100x = Math.floor((XX) / 100000);
        const z100y = Math.floor((YY) / 100000);
        let x100;
        x100 = ((GridZoneL - (Math.floor(GridZoneL / 3) * 3)) - 1) * 8 + z100x;
        if (x100 < 0) {
            x100 = x100 + 24;
        }
        ;
        let y100;
        y100 = z100y - Math.floor(z100y / 20) * 20 + 1;
        //Letter Square
        let LX100;
        let LY100;
        switch (x100) {
            case 1:
                LX100 = 'A';
                break;
            case 2:
                LX100 = 'B';
                break;
            case 3:
                LX100 = 'C';
                break;
            case 4:
                LX100 = 'D';
                break;
            case 5:
                LX100 = 'E';
                break;
            case 6:
                LX100 = 'F';
                break;
            case 7:
                LX100 = 'G';
                break;
            case 8:
                LX100 = 'H';
                break;
            case 9:
                LX100 = 'J';
                break;
            case 10:
                LX100 = 'K';
                break;
            case 11:
                LX100 = 'L';
                break;
            case 12:
                LX100 = 'M';
                break;
            case 13:
                LX100 = 'N';
                break;
            case 14:
                LX100 = 'P';
                break;
            case 15:
                LX100 = 'Q';
                break;
            case 16:
                LX100 = 'R';
                break;
            case 17:
                LX100 = 'S';
                break;
            case 18:
                LX100 = 'T';
                break;
            case 19:
                LX100 = 'U';
                break;
            case 20:
                LX100 = 'V';
                break;
            case 21:
                LX100 = 'W';
                break;
            case 22:
                LX100 = 'X';
                break;
            case 23:
                LX100 = 'Y';
                break;
            case 24:
                LX100 = 'Z';
                break;
        }
        if ((GridZoneL - Math.floor(GridZoneL / 2) * 2) == 0) {
            y100 = y100 + 5;
        } //Se Artia Zoni, metathesi tou deyteroy xaraktira
        if (y100 > 20) {
            y100 = y100 - 20;
        } //Oi xaraktires gia Y epanalambanontai. Arameta ton 20 epistrefo
        switch (y100) {
            case 1:
                LY100 = 'A';
                break;
            case 2:
                LY100 = 'B';
                break;
            case 3:
                LY100 = 'C';
                break;
            case 4:
                LY100 = 'D';
                break;
            case 5:
                LY100 = 'E';
                break;
            case 6:
                LY100 = 'F';
                break;
            case 7:
                LY100 = 'G';
                break;
            case 8:
                LY100 = 'H';
                break;
            case 9:
                LY100 = 'J';
                break;
            case 10:
                LY100 = 'K';
                break;
            case 11:
                LY100 = 'L';
                break;
            case 12:
                LY100 = 'M';
                break;
            case 13:
                LY100 = 'N';
                break;
            case 14:
                LY100 = 'P';
                break;
            case 15:
                LY100 = 'Q';
                break;
            case 16:
                LY100 = 'R';
                break;
            case 17:
                LY100 = 'S';
                break;
            case 18:
                LY100 = 'T';
                break;
            case 19:
                LY100 = 'U';
                break;
            case 20:
                LY100 = 'V';
                break;
        }
        let xxxx = XX - Math.floor((XX) / 100000) * 100000;
        let yyyy = YY - Math.floor((YY) / 100000) * 100000;
        xxxx = Math.round(xxxx);
        yyyy = Math.round(yyyy);
        const out = {
            GridZone: GridZone,
            GridZoneF: GridZoneF,
            GridZoneL: GridZoneL,
            LX100: LX100,
            LY100: LY100,
            x: xxxx,
            y: yyyy,
            x_utm: XX,
            y_utm: YY
        };
        return out;
    }
    fl2MGRS(f, l) {
        //lng 		+-180 mode
        //get lng 	0-360 mode
        const pi = Math.PI;
        const lt = l + 180;
        //get zone
        const GridZoneL = Math.floor(lt / 6) + 1;
        //get f from -80  
        let ft = f + 80;
        ft = Math.floor(ft / 8) + 1;
        let GridZoneF = '';
        //Zone Band
        switch (ft) {
            case 1:
                GridZoneF = 'C';
                break;
            case 2:
                GridZoneF = 'D';
                break;
            case 3:
                GridZoneF = 'E';
                break;
            case 4:
                GridZoneF = 'F';
                break;
            case 5:
                GridZoneF = 'G';
                break;
            case 6:
                GridZoneF = 'H';
                break;
            case 7:
                GridZoneF = 'J';
                break;
            case 8:
                GridZoneF = 'K';
                break;
            case 9:
                GridZoneF = 'L';
                break;
            case 10:
                GridZoneF = 'M';
                break;
            case 11:
                GridZoneF = 'N';
                break;
            case 12:
                GridZoneF = 'P';
                break;
            case 13:
                GridZoneF = 'Q';
                break;
            case 14:
                GridZoneF = 'R';
                break;
            case 15:
                GridZoneF = 'S';
                break;
            case 16:
                GridZoneF = 'T';
                break;
            case 17:
                GridZoneF = 'U';
                break;
            case 18:
                GridZoneF = 'V';
                break;
            case 19:
                GridZoneF = 'W';
                break;
            case 20:
                GridZoneF = 'X';
                break;
            case 21:
                ft = 20;
                GridZoneF = 'C';
                break;
        }
        const GridZone = GridZoneL + GridZoneF;
        let Fo = 0;
        let Lo = GridZoneL * 6 - 3;
        const w = 6;
        Lo = Lo - 180;
        const k0 = 0.9996;
        Fo = Fo * pi / 180;
        Lo = Lo * pi / 180;
        f = f * pi / 180;
        l = l * pi / 180;
        const e = this.wgs84_e;
        const a = this.wgs84_a;
        const pT = Math.tan(f) * Math.tan(f);
        const pC = (Math.pow(e, 2)) * (Math.pow(Math.cos(f), 2)) / (1 - Math.pow(e, 2));
        const pA = (l - Lo) * Math.cos(f);
        const pn = a / Math.sqrt(1 - (e * e) * (Math.sin(f) * Math.sin(f)));
        let pM = (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256) * f;
        pM = pM - (3 * Math.pow(e, 2) / 8 + 3 * Math.pow(e, 4) / 32 + 45 * Math.pow(e, 6) / 1024) * Math.sin(2 * f);
        pM = pM + (15 * Math.pow(e, 4) / 256 + 45 * Math.pow(e, 6) / 1024) * Math.sin(4 * f);
        pM = pM - (35 * Math.pow(e, 6) / 3072) * Math.sin(6 * f);
        pM = pM * a;
        let pM0 = (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256) * Fo;
        pM0 = pM0 - (3 * Math.pow(e, 2) / 8 + 3 * Math.pow(e, 4) / 32 + 45 * Math.pow(e, 6) / 1024) * Math.sin(2 * Fo);
        pM0 = pM0 + (15 * Math.pow(e, 4) / 256 + 45 * Math.pow(e, 6) / 1024) * Math.sin(4 * Fo);
        pM0 = pM0 - (35 * Math.pow(e, 6) / 3072) * Math.sin(6 * Fo);
        pM0 = pM0 * a;
        const et = Math.sqrt(e * e / (1 - e * e));
        //Compute UTM X
        //Ypologismos UTM X
        const XX = 500000 + k0 * pn * (pA + (1 - pT + pC) * pA * pA * pA / 6 + (5 - 18 * pT + pT * pT + 72 * pC - 58 * et * et) * pA * pA * pA * pA * pA / 120);
        //Compute UTM Y
        //Ypologismos UTM Y
        let YY = pA * pA / 2;
        YY = YY + (5 - pT + 9 * pC + 4 * pC * pC) * pA * pA * pA * pA / 24;
        YY = YY + (61 - 58 * pT + pT * pT + 600 * pC - 330 * et * et) * Math.pow(pA, 6) / 720;
        YY = YY * pn * Math.tan(f);
        YY = YY + pM - pM0;
        YY = YY * k0;
        YY = YY;
        //Y offset for South Hemisphere
        if (f < 0) {
            YY = YY + 10000000;
        }
        const z100x = Math.floor((XX) / 100000);
        const z100y = Math.floor((YY) / 100000);
        let x100;
        x100 = ((GridZoneL - (Math.floor(GridZoneL / 3) * 3)) - 1) * 8 + z100x;
        if (x100 < 0) {
            x100 = x100 + 24;
        }
        ;
        let y100;
        y100 = z100y - Math.floor(z100y / 20) * 20 + 1;
        let LX100;
        let LY100;
        switch (x100) {
            case 1:
                LX100 = 'A';
                break;
            case 2:
                LX100 = 'B';
                break;
            case 3:
                LX100 = 'C';
                break;
            case 4:
                LX100 = 'D';
                break;
            case 5:
                LX100 = 'E';
                break;
            case 6:
                LX100 = 'F';
                break;
            case 7:
                LX100 = 'G';
                break;
            case 8:
                LX100 = 'H';
                break;
            case 9:
                LX100 = 'J';
                break;
            case 10:
                LX100 = 'K';
                break;
            case 11:
                LX100 = 'L';
                break;
            case 12:
                LX100 = 'M';
                break;
            case 13:
                LX100 = 'N';
                break;
            case 14:
                LX100 = 'P';
                break;
            case 15:
                LX100 = 'Q';
                break;
            case 16:
                LX100 = 'R';
                break;
            case 17:
                LX100 = 'S';
                break;
            case 18:
                LX100 = 'T';
                break;
            case 19:
                LX100 = 'U';
                break;
            case 20:
                LX100 = 'V';
                break;
            case 21:
                LX100 = 'W';
                break;
            case 22:
                LX100 = 'X';
                break;
            case 23:
                LX100 = 'Y';
                break;
            case 24:
                LX100 = 'Z';
                break;
        }
        if ((GridZoneL - Math.floor(GridZoneL / 2) * 2) == 0) {
            y100 = y100 + 5;
        }
        if (y100 > 20) {
            y100 = y100 - 20;
        }
        switch (y100) {
            case 1:
                LY100 = 'A';
                break;
            case 2:
                LY100 = 'B';
                break;
            case 3:
                LY100 = 'C';
                break;
            case 4:
                LY100 = 'D';
                break;
            case 5:
                LY100 = 'E';
                break;
            case 6:
                LY100 = 'F';
                break;
            case 7:
                LY100 = 'G';
                break;
            case 8:
                LY100 = 'H';
                break;
            case 9:
                LY100 = 'J';
                break;
            case 10:
                LY100 = 'K';
                break;
            case 11:
                LY100 = 'L';
                break;
            case 12:
                LY100 = 'M';
                break;
            case 13:
                LY100 = 'N';
                break;
            case 14:
                LY100 = 'P';
                break;
            case 15:
                LY100 = 'Q';
                break;
            case 16:
                LY100 = 'R';
                break;
            case 17:
                LY100 = 'S';
                break;
            case 18:
                LY100 = 'T';
                break;
            case 19:
                LY100 = 'U';
                break;
            case 20:
                LY100 = 'V';
                break;
        }
        let xxxx = XX - Math.floor((XX) / 100000) * 100000;
        let yyyy = YY - Math.floor((YY) / 100000) * 100000;
        xxxx = Math.round(xxxx);
        yyyy = Math.round(yyyy);
        const out = {
            GridZone: GridZone,
            GridZoneF: GridZoneF,
            GridZoneL: GridZoneL,
            LX100: LX100,
            LY100: LY100,
            x: xxxx,
            y: yyyy,
            x_utm: XX,
            y_utm: YY
        };
        return out;
    }
    /*
    //Remove Large Grid
    kanRemove() {
        this.kanPut = false;
        for (let i = 1; i <= this.kanN; i++) {
            this.kan[i].setMap(null);
        }
        this.kanN = 0;
    }
    
    
    
    //Remove Small Grid
    lkanRemove() {
        this.lkanPut = false;
        for (let i = 1; i <= this.lkanN; i++) {
    
            this.lkan[i].setMap(null);
        }
        this.lkanN = 0;
    }
    
    */
    /*
    //UTM Zone Grid WGS 84
    kanavos() {
    
        let ar1;
        let ar2;
        let coors;
    
    
        //  Zones
        ////////////////////////////////////////////////////////////////////////////////
        for (let i = 32; i <= 50; i = i + 8) {
            ar1 = new google.maps.LatLng(i, 10);
            ar2 = new google.maps.LatLng(i, 40);
            coors = [ar1, ar2];	//,ar1,belos2,ar2];
    
            kanN += 1;
            kan[kanN] = new google.maps.Polyline({
                path: coors,
                strokeColor: "#d00",
                strokeOpacity: 1,
                strokeWeight: 2
            });
            kan[kanN].setMap(map);
        }
    
        /////////////////////////////////////////////////////////////////////////////////
    
    
    
    
    
    
        for (i = 33; i <= 37; i++) {
    
            a = UTM_xy2fl(500000, 0, i, 0);
    
            f0 = Math.round(a[1]);
            f1 = f0 - 3;
            f2 = f0 + 3;
    
            ar1 = new google.maps.LatLng(31, f1);
            ar2 = new google.maps.LatLng(49, f1);
            coors = [ar1, ar2];
    
            kanN += 1;
            kan[kanN] = new google.maps.Polyline({
                path: coors,
                strokeColor: "#d00",
                strokeOpacity: 1,
                strokeWeight: 2
            });
            kan[kanN].setMap(map);
    
        }
    
    
        kanPut = true;
    }
    */
    /*
    
    //UTM Zone Grid ED 50
    kanavosED50() {
    
        var ar1;
        var ar2;
        var coors;
    
    
    
    
        //  Zones
        ////////////////////////////////////////////////////////////////////////////////
        for (i = 32; i <= 50; i = i + 8) {
            var bb1 = fled50towgs84(i, 10, 0);
            var bb2 = fled50towgs84(i, 40, 0);
            ar1 = new google.maps.LatLng(bb1[0], bb1[1]);
            ar2 = new google.maps.LatLng(bb2[0], bb2[1]);
    
            coors = [ar1, ar2];	//,ar1,belos2,ar2];
    
            kanN += 1;
            kan[kanN] = new google.maps.Polyline({
                path: coors,
                strokeColor: "#d00",
                strokeOpacity: 1,
                strokeWeight: 2
            });
            kan[kanN].setMap(map);
        }
    
    
        /////////////////////////////////////////////////////////////////////////////////
    
    
    
    
    
    
        for (i = 33; i <= 37; i++) {
    
            a = ED50_xy2fl(500000, 0, i, 0);
    
            f0 = Math.round(a[1]);
            f1 = f0 - 3;
            f2 = f0 + 3;
    
    
    
    
    
    
    
            var aa1 = fled50towgs84(31, f1, 0);
            var aa2 = fled50towgs84(49, f1, 0);
    
            ar1 = new google.maps.LatLng(aa1[0], aa1[1]);
            ar2 = new google.maps.LatLng(aa2[0], aa2[1]);
    
            coors = [ar1, ar2];
    
    
            kanN += 1;
            kan[kanN] = new google.maps.Polyline({
                path: coors,
                strokeColor: "#d00",
                strokeOpacity: 1,
                strokeWeight: 2
            });
            kan[kanN].setMap(map);
        }
    
        kanPut = true;
    }
    
    */
    //Get UTM Zone
    getUTMZone(lon) {
        const lt = lon + 180;
        const out = Math.floor(lt / 6) + 1;
        return out;
    }
    //Get Zone L0
    getUTMZoneL0(zone) {
        const lt = (zone - 1) * 6 - 180 + 3;
        return lt;
    }
    /*
    //100km Grid WGS 84 - Create
    zonekan(z) {
    
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
    
        var UTM = fl2MGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 100000);
        y0 = Math.round(y0 / 100000);
    
    
    
        for (i = y0 - 5; i <= y0 + 5; i++) {
    
            for (j = -7; j <= +7; j++) {
    
                var a1 = UTM_xy2fl(j * 100000, i * 100000, z, 0);
                var a2 = UTM_xy2fl(j * 100000 + 100000, i * 100000, z, 0);
                var a3 = UTM_xy2fl(j * 100000, i * 100000 + 100000, z, 0);
                var a4 = UTM_xy2fl(j * 100000 + 100000, i * 100000 + 100000, z, 0);
    
                if (getZoneL0(z) - 3 <= Math.floor(a1[1]) && getZoneL0(z) + 3 >= Math.floor(a2[1]) + 1) {
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];	//,ar1,belos2,ar2];
    
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
                else if (getZoneL0(z) + 3 < Math.floor(a2[1]) + 1 && getZoneL0(z) + 3 > Math.floor(a1[1])) {
    
    
                    var s1 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], a2[1]));
                    var s2 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], getZoneL0(z) + 3));
    
                    var dx = 100000 * s2 / s1;
                    var a2 = UTM_xy2fl(j * 100000 + dx, i * 100000, z, 0);
                    a2[1] = getZoneL0(z) + 3;
    
                    var s1 = dist00(new google.maps.LatLng(a4[0], a4[1]), new google.maps.LatLng(a3[0], a3[1]));
                    var s2 = dist00(new google.maps.LatLng(a3[0], a3[1]), new google.maps.LatLng(a4[0], getZoneL0(z) + 3));
    
                    var dx = 100000 * s2 / s1;
                    var a4 = UTM_xy2fl(j * 100000 + dx + 100000, i * 100000 + 100000, z, 0);
                    a4[1] = getZoneL0(z) + 3;
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];	//,ar1,belos2,ar2];
    
    
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
                else if (getZoneL0(z) - 3 > Math.floor(a1[1]) && getZoneL0(z) - 3 < Math.floor(a2[1]) + 1) {
    
                    var s1 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], a2[1]));
                    var s2 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], getZoneL0(z) - 3));
    
                    var dx = 100000 * s2 / s1;
                    var a1 = UTM_xy2fl(j * 100000 + dx, i * 100000, z, 0);
                    a1[1] = getZoneL0(z) - 3;
    
                    var s1 = dist00(new google.maps.LatLng(a4[0], a4[1]), new google.maps.LatLng(a3[0], a3[1]));
                    var s2 = dist00(new google.maps.LatLng(a3[0], a3[1]), new google.maps.LatLng(a4[0], getZoneL0(z) - 3));
    
                    var dx = 100000 * s2 / s1;
                    var a3 = UTM_xy2fl(j * 100000 + dx, i * 100000 + 100000, z, 0);
                    a3[1] = getZoneL0(z) - 3;
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];	//,ar1,belos2,ar2];
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
            }
        }
    
    }
    */
    /*
    //100km Grid ED50 - Create
    function zonekanED50(z) {
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
    
        var UTM = fl2MGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 100000);
        y0 = Math.round(y0 / 100000);
    
    
    
        for (i = y0 - 5; i <= y0 + 5; i++) {
    
            for (j = -7; j <= +7; j++) {
    
                var a1 = ED50_xy2fl(j * 100000, i * 100000, z, 0);
                a1 = fled50towgs84(a1[0], a1[1], 0);
                var a2 = ED50_xy2fl(j * 100000 + 100000, i * 100000, z, 0);
                a2 = fled50towgs84(a2[0], a2[1], 0);
                var a3 = ED50_xy2fl(j * 100000, i * 100000 + 100000, z, 0);
                a3 = fled50towgs84(a3[0], a3[1], 0);
                var a4 = ED50_xy2fl(j * 100000 + 100000, i * 100000 + 100000, z, 0);
                a4 = fled50towgs84(a4[0], a4[1], 0);
    
                if (getZoneL0(z) - 3 <= Math.floor(a1[1]) && getZoneL0(z) + 3 >= Math.floor(a2[1]) + 1) {
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
                else if (getZoneL0(z) + 3 < Math.floor(a2[1]) + 1 && getZoneL0(z) + 3 > Math.floor(a1[1])) {
    
                    var s1 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], a2[1]));
                    var s2 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], getZoneL0(z) + 3));
    
                    var dx = 100000 * s2 / s1;
                    var a2 = ED50_xy2fl(j * 100000 + dx, i * 100000, z, 0);
                    a2[1] = getZoneL0(z) + 3;
                    a2 = fled50towgs84(a2[0], a2[1], 0);
    
                    var s1 = dist00(new google.maps.LatLng(a4[0], a4[1]), new google.maps.LatLng(a3[0], a3[1]));
                    var s2 = dist00(new google.maps.LatLng(a3[0], a3[1]), new google.maps.LatLng(a4[0], getZoneL0(z) + 3));
    
                    var dx = 100000 * s2 / s1;
                    var a4 = ED50_xy2fl(j * 100000 + dx + 100000, i * 100000 + 100000, z, 0);
                    a4[1] = getZoneL0(z) + 3;
                    a4 = fled50towgs84(a4[0], a4[1], 0);
    
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
                else if (getZoneL0(z) - 3 > Math.floor(a1[1]) && getZoneL0(z) - 3 < Math.floor(a2[1]) + 1) {
    
                    var s1 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], a2[1]));
                    var s2 = dist00(new google.maps.LatLng(a1[0], a1[1]), new google.maps.LatLng(a2[0], getZoneL0(z) - 3));
    
                    var dx = 100000 * s2 / s1;
                    var a1 = ED50_xy2fl(j * 100000 + dx, i * 100000, z, 0);
                    a1[1] = getZoneL0(z) - 3;
                    a1 = fled50towgs84(a1[0], a1[1], 0);
    
                    var s1 = dist00(new google.maps.LatLng(a4[0], a4[1]), new google.maps.LatLng(a3[0], a3[1]));
                    var s2 = dist00(new google.maps.LatLng(a3[0], a3[1]), new google.maps.LatLng(a4[0], getZoneL0(z) - 3));
    
                    var dx = 100000 * s2 / s1;
                    var a3 = ED50_xy2fl(j * 100000 + dx, i * 100000 + 100000, z, 0);
                    a3[1] = getZoneL0(z) - 3;
                    a3 = fled50towgs84(a3[0], a3[1], 0);
    
    
    
                    ar1 = new google.maps.LatLng(a1[0], a1[1]);
                    ar2 = new google.maps.LatLng(a2[0], a2[1]);
                    ar3 = new google.maps.LatLng(a3[0], a3[1]);
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4];
    
                    kanN += 1;
                    kan[kanN] = new google.maps.Polyline({
                        path: coors,
                        strokeColor: "#d0d",
                        strokeOpacity: 1,
                        strokeWeight: 1
                    });
                    kan[kanN].setMap(map);
    
                }
            }
        }
    }
    
    */
    /*
    //Triger 100km Grid WGS 84
    function mkan() {
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
    
        var z = getZone(c0);
        var UTM = fl2MGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 100000);
        y0 = Math.round(y0 / 100000);
    
        var z2;
        if (getZoneL0(getZone(c0)) > c0) { z2 = z - +1; } else { z2 = z + 1 }
        zonekan(z2);
        zonekan(z);
    
        kanPut = true;
    
    }
    
    */
    /*
    //Triger 100km Grid ED50
    function mkanED50() {
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
    
        var z = getZone(c0);
        var UTM = fl2MGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 100000);
        y0 = Math.round(y0 / 100000);
    
        var z2;
        if (getZoneL0(getZone(c0)) > c0) { z2 = z - +1; } else { z2 = z + 1 }
        zonekanED50(z2);
        zonekanED50(z);
    
        kanPut = true;
    }
    
    */
    /*
    //1000m Grid WGS 84 - Create
    function kan100() {
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
        var UTM = fl2MGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 1000);
        y0 = Math.round(y0 / 1000);
    
        for (i = y0 - 5; i <= y0 + 5; i++) {
    
            for (j = x0 - 5; j <= x0 + 5; j++) {
    
                var a1 = UTM_xy2fl(j * 1000, i * 1000, getZone(c0), 0);
                var a2 = UTM_xy2fl(j * 1000 + 1000, i * 1000, getZone(c0), 0);
                var a3 = UTM_xy2fl(j * 1000, i * 1000 + 1000, getZone(c0), 0);
                var a4 = UTM_xy2fl(j * 1000 + 1000, i * 1000 + 1000, getZone(c0), 0);
    
                ar1 = new google.maps.LatLng(a1[0], a1[1]);
                ar2 = new google.maps.LatLng(a2[0], a2[1]);
                ar3 = new google.maps.LatLng(a3[0], a3[1]);
    
    
                if (j == x0 + 5) {
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4, ar3];
                } else if (i == y0 + 5) {
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4, ar3];
                } else {
                    coors = [ar3, ar1, ar2];
                }
    
                lkanN += 1;
                lkan[lkanN] = new google.maps.Polyline({
                    path: coors,
                    strokeColor: "#d0d",
                    strokeOpacity: 1,
                    strokeWeight: 1
                });
                lkan[lkanN].setMap(map);
            }
        }
        lkanPut = true;
    }
    
    
    */
    /*
    //1000m Grid WGS 84 - Create
    function kan100ED50() {
    
        var c = curlatLng;
        c0 = c.lng();
        d0 = c.lat();
        var UTM = fl2EDMGRS(d0, c0);
    
        x0 = UTM[6];
        y0 = UTM[7];
    
    
        x0 = Math.round(x0 / 1000);
        y0 = Math.round(y0 / 1000);
    
    
        for (i = y0 - 5; i <= y0 + 5; i++) {
    
            for (j = x0 - 5; j <= x0 + 5; j++) {
    
                var a1 = ED50_xy2fl(j * 1000, i * 1000, getZone(c0), 0);
                a1 = fled50towgs84(a1[0], a1[1], 0);
                var a2 = ED50_xy2fl(j * 1000 + 1000, i * 1000, getZone(c0), 0);
                a2 = fled50towgs84(a2[0], a2[1], 0);
                var a3 = ED50_xy2fl(j * 1000, i * 1000 + 1000, getZone(c0), 0);
                a3 = fled50towgs84(a3[0], a3[1], 0);
                var a4 = ED50_xy2fl(j * 1000 + 1000, i * 1000 + 1000, getZone(c0), 0);
                a4 = fled50towgs84(a4[0], a4[1], 0);
    
                ar1 = new google.maps.LatLng(a1[0], a1[1]);
                ar2 = new google.maps.LatLng(a2[0], a2[1]);
                ar3 = new google.maps.LatLng(a3[0], a3[1]);
    
    
                if (j == x0 + 5) {
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4, ar3];
                } else if (i == y0 + 5) {
                    ar4 = new google.maps.LatLng(a4[0], a4[1]);
                    coors = [ar3, ar1, ar2, ar4, ar3];
                } else {
                    coors = [ar3, ar1, ar2];
                }
    
    
                lkanN += 1;
                lkan[lkanN] = new google.maps.Polyline({
                    path: coors,
                    strokeColor: "#d0d",
                    strokeOpacity: 1,
                    strokeWeight: 1
                });
    
                lkan[lkanN].setMap(map);
            }
        }
        lkanPut = true;
    }
    
    */
    // Output WGS 84  lat, lng
    UTM_xy2fl(XX, YY, z, Hemisphere = 0) {
        if (Hemisphere === 1) {
            YY = YY - 10000000;
        }
        const pi = Math.PI;
        const out = new Array();
        let FE; //False Easting
        let FN; //False Northing
        let k0; //Scale
        let F0;
        let l1;
        let W;
        let L0;
        FE = 500000;
        FN = 0;
        k0 = 0.9996;
        F0 = 0 * pi / 180;
        l1 = -180 * pi / 180;
        W = 6 * pi / 180;
        const LastZone = z;
        L0 = z * W - (-l1 + W / 2);
        while (L0 > 180 * 4 * Math.atan(1) / 180) {
            L0 = L0 - 360 * 4 * Math.atan(1) / 180;
        }
        while (L0 < -180 * 4 * Math.atan(1) / 180) {
            L0 = L0 + 360 * 4 * Math.atan(1) / 180;
        }
        let ee;
        ee = this.wgs84_e;
        let et;
        et = Math.sqrt(ee * ee / (1 - ee * ee));
        let aa;
        aa = this.wgs84_a;
        let pM0;
        pM0 = (1 - Math.pow(ee, 2) / 4 - 3 * Math.pow(ee, 4) / 64 - 5 * Math.pow(ee, 6) / 256) * F0;
        pM0 = pM0 - (3 * Math.pow(ee, 2) / 8 + 3 * Math.pow(ee, 4) / 32 + 45 * Math.pow(ee, 6) / 1024) * Math.sin(2 * F0);
        pM0 = pM0 + (15 * Math.pow(ee, 4) / 256 + 45 * Math.pow(ee, 6) / 1024) * Math.sin(4 * F0);
        pM0 = pM0 - (35 * Math.pow(ee, 6) / 3072) * Math.sin(6 * F0);
        pM0 = pM0 * aa;
        let pe1;
        let pm1;
        let pMm1;
        let pT1;
        let pC1;
        let pD;
        pe1 = (1 - Math.sqrt((1 - ee * ee))) / (1 + Math.sqrt((1 - ee * ee)));
        pMm1 = pM0 + (YY - FN) / k0;
        pm1 = pMm1 / (aa * (1 - Math.pow(ee, 2) / 4 - 3 * Math.pow(ee, 4) / 64 - 5 * Math.pow(ee, 6) / 256));
        let f1;
        f1 = (3 * pe1 / 2 - 27 * pe1 * pe1 * pe1 / 32) * Math.sin(2 * pm1);
        f1 = f1 + (21 * pe1 * pe1 / 16 - 55 * pe1 * pe1 * pe1 * pe1 / 32) * Math.sin(4 * pm1);
        f1 = f1 + (151 * pe1 * pe1 * pe1 / 96) * Math.sin(6 * pm1);
        f1 = f1 + (1097 * pe1 * pe1 * pe1 * pe1 / 512) * Math.sin(8 * pm1);
        f1 = f1 + pm1;
        pT1 = Math.tan(f1) * Math.tan(f1);
        pC1 = et * et * Math.cos(f1) * Math.cos(f1);
        let pn1;
        let pr1;
        pn1 = aa / Math.sqrt(1 - ee * ee * Math.sin(f1) * Math.sin(f1));
        pr1 = aa * (1 - ee * ee) / Math.sqrt(Math.pow((1 - ee * ee * Math.sin(f1) * Math.sin(f1)), 3));
        pD = (XX - (FE)) / (pn1 * k0);
        let f;
        let l;
        f = pD * pD / 2;
        f = f - (5 + 3 * pT1 + 10 * pC1 - 4 * pC1 * pC1 - 9 * et * et) * pD * pD * pD * pD / 24;
        f = f + (61 + 90 * pT1 + 298 * pC1 + 45 * pT1 * pT1 - 252 * et * et - 3 * pC1 * pC1) * pD * pD * pD * pD * pD * pD / 720;
        f = -(pn1 * Math.tan(f1) / pr1) * f;
        f = f1 + f;
        l = pD;
        l = l - (1 + 2 * pT1 + pC1) * pD * pD * pD / 6;
        l = l + (5 - 2 * pC1 + 28 * pT1 - 3 * pC1 * pC1 + 8 * et * et + 24 * pT1 * pT1) * pD * pD * pD * pD * pD / 120;
        l = l / Math.cos(f1);
        l = l + L0;
        out[0] = f * 180 / pi;
        out[1] = l * 180 / pi;
        return out;
    }
    // Output WGS 84  lat, lng
    ED50_xy2fl(XX, YY, z, Hemisphere = 0) {
        if (Hemisphere === 1) {
            YY = YY - 10000000;
        }
        const pi = Math.PI;
        let FE; //False Easting
        let FN; //False Northing
        let k0; //Scale
        let F0;
        let l1;
        let W;
        let L0;
        //Set_UTM_Params 0, -180, 6, 0.9996, 500000, 0
        FE = 500000;
        FN = 0;
        k0 = 0.9996;
        F0 = 0 * pi / 180;
        l1 = -180 * pi / 180;
        W = 6 * pi / 180;
        const LastZone = z;
        L0 = z * W - (-l1 + W / 2);
        while (L0 > 180 * 4 * Math.atan(1) / 180) {
            L0 = L0 - 360 * 4 * Math.atan(1) / 180;
        }
        while (L0 < -180 * 4 * Math.atan(1) / 180) {
            L0 = L0 + 360 * 4 * Math.atan(1) / 180;
        }
        let ee;
        ee = this.ED_e;
        let et;
        et = Math.sqrt(ee * ee / (1 - ee * ee));
        let aa;
        aa = this.ED_a;
        let pM0;
        pM0 = (1 - Math.pow(ee, 2) / 4 - 3 * Math.pow(ee, 4) / 64 - 5 * Math.pow(ee, 6) / 256) * F0;
        pM0 = pM0 - (3 * Math.pow(ee, 2) / 8 + 3 * Math.pow(ee, 4) / 32 + 45 * Math.pow(ee, 6) / 1024) * Math.sin(2 * F0);
        pM0 = pM0 + (15 * Math.pow(ee, 4) / 256 + 45 * Math.pow(ee, 6) / 1024) * Math.sin(4 * F0);
        pM0 = pM0 - (35 * Math.pow(ee, 6) / 3072) * Math.sin(6 * F0);
        pM0 = pM0 * aa;
        let pe1;
        let pm1;
        let pMm1;
        let pT1;
        let pC1;
        let pD;
        pe1 = (1 - Math.sqrt((1 - ee * ee))) / (1 + Math.sqrt((1 - ee * ee)));
        pMm1 = pM0 + (YY - FN) / k0;
        pm1 = pMm1 / (aa * (1 - Math.pow(ee, 2) / 4 - 3 * Math.pow(ee, 4) / 64 - 5 * Math.pow(ee, 6) / 256));
        let f1;
        f1 = (3 * pe1 / 2 - 27 * pe1 * pe1 * pe1 / 32) * Math.sin(2 * pm1);
        f1 = f1 + (21 * pe1 * pe1 / 16 - 55 * pe1 * pe1 * pe1 * pe1 / 32) * Math.sin(4 * pm1);
        f1 = f1 + (151 * pe1 * pe1 * pe1 / 96) * Math.sin(6 * pm1);
        f1 = f1 + (1097 * pe1 * pe1 * pe1 * pe1 / 512) * Math.sin(8 * pm1);
        f1 = f1 + pm1;
        pT1 = Math.tan(f1) * Math.tan(f1);
        pC1 = et * et * Math.cos(f1) * Math.cos(f1);
        let pn1;
        let pr1;
        pn1 = aa / Math.sqrt(1 - ee * ee * Math.sin(f1) * Math.sin(f1));
        pr1 = aa * (1 - ee * ee) / Math.sqrt(Math.pow((1 - ee * ee * Math.sin(f1) * Math.sin(f1)), 3));
        pD = (XX - (FE)) / (pn1 * k0);
        let f;
        let l;
        f = pD * pD / 2;
        f = f - (5 + 3 * pT1 + 10 * pC1 - 4 * pC1 * pC1 - 9 * et * et) * pD * pD * pD * pD / 24;
        f = f + (61 + 90 * pT1 + 298 * pC1 + 45 * pT1 * pT1 - 252 * et * et - 3 * pC1 * pC1) * pD * pD * pD * pD * pD * pD / 720;
        f = -(pn1 * Math.tan(f1) / pr1) * f;
        f = f1 + f;
        l = pD;
        l = l - (1 + 2 * pT1 + pC1) * pD * pD * pD / 6;
        l = l + (5 - 2 * pC1 + 28 * pT1 - 3 * pC1 * pC1 + 8 * et * et + 24 * pT1 * pT1) * pD * pD * pD * pD * pD / 120;
        l = l / Math.cos(f1);
        l = l + L0;
        // const out2 = this.fled50towgs84(out[0], out[1]);
        return [f * 180 / pi, l * 180 / pi];
    }
    MGRS2UTM(GZD, t100, x, y) {
        let z1;
        z1 = parseInt(GZD.substring(0, GZD.length - 1));
        const z2 = GZD.substring(GZD.length - 1, 3);
        const t1 = t100.substring(0, 1);
        const t2 = t100.substring(1, 2);
        let ft;
        switch (z2) {
            case 'C':
                ft = 1;
                break;
            case 'D':
                ft = 2;
                break;
            case 'E':
                ft = 3;
                break;
            case 'F':
                ft = 4;
                break;
            case 'G':
                ft = 5;
                break;
            case 'H':
                ft = 6;
                break;
            case 'J':
                ft = 7;
                break;
            case 'K':
                ft = 8;
                break;
            case 'L':
                ft = 9;
                break;
            case 'M':
                ft = 10;
                break;
            case 'N':
                ft = 11;
                break;
            case 'P':
                ft = 12;
                break;
            case 'Q':
                ft = 13;
                break;
            case 'R':
                ft = 14;
                break;
            case 'S':
                ft = 15;
                break;
            case 'T':
                ft = 16;
                break;
            case 'U':
                ft = 17;
                break;
            case 'V':
                ft = 18;
                break;
            case 'W':
                ft = 19;
                break;
            case 'X':
                ft = 20;
                break;
        }
        ft = ft - 10;
        let x100;
        let y100;
        switch (t1) {
            case 'A':
                x100 = 1;
                break;
            case 'B':
                x100 = 2;
                break;
            case 'C':
                x100 = 3;
                break;
            case 'D':
                x100 = 4;
                break;
            case 'E':
                x100 = 5;
                break;
            case 'F':
                x100 = 6;
                break;
            case 'G':
                x100 = 7;
                break;
            case 'H':
                x100 = 8;
                break;
            case 'J':
                x100 = 1;
                break;
            case 'K':
                x100 = 2;
                break;
            case 'L':
                x100 = 3;
                break;
            case 'M':
                x100 = 4;
                break;
            case 'N':
                x100 = 5;
                break;
            case 'P':
                x100 = 6;
                break;
            case 'Q':
                x100 = 7;
                break;
            case 'R':
                x100 = 8;
                break;
            case 'S':
                x100 = 1;
                break;
            case 'T':
                x100 = 2;
                break;
            case 'U':
                x100 = 3;
                break;
            case 'V':
                x100 = 4;
                break;
            case 'W':
                x100 = 5;
                break;
            case 'X':
                x100 = 6;
                break;
            case 'Y':
                x100 = 7;
                break;
            case 'Z':
                x100 = 8;
                break;
        }
        switch (t2) {
            case 'A':
                y100 = 1;
                break;
            case 'B':
                y100 = 2;
                break;
            case 'C':
                y100 = 3;
                break;
            case 'D':
                y100 = 4;
                break;
            case 'E':
                y100 = 5;
                break;
            case 'F':
                y100 = 6;
                break;
            case 'G':
                y100 = 7;
                break;
            case 'H':
                y100 = 8;
                break;
            case 'J':
                y100 = 9;
                break;
            case 'K':
                y100 = 10;
                break;
            case 'L':
                y100 = 11;
                break;
            case 'M':
                y100 = 12;
                break;
            case 'N':
                y100 = 13;
                break;
            case 'P':
                y100 = 14;
                break;
            case 'Q':
                y100 = 15;
                break;
            case 'R':
                y100 = 16;
                break;
            case 'S':
                y100 = 17;
                break;
            case 'T':
                y100 = 18;
                break;
            case 'U':
                y100 = 19;
                break;
            case 'V':
                y100 = 20;
                break;
        }
        let z100x = x100 * 100000;
        y100 = y100 - 1;
        if ((z1 - Math.floor(z1 / 2) * 2) == 0) {
            y100 = y100 - 5;
        }
        if (y100 < 0) {
            y100 = y100 + 20;
        }
        let tempx;
        tempx = z100x + x;
        let tempy;
        let tempy100;
        for (let i = 1; i < 10; i++) {
            tempy100 = y100 + (i - 1) * 20;
            tempy = tempy100 * 100000 + y;
            const UTM = this.UTM_xy2fl(tempx * 1.0, tempy * 1.0, z1 * 1.0, 0);
            const UTM2 = this.fl2MGRS(UTM[0], UTM[1]);
            if (UTM2.GridZoneF === z2 && UTM2.GridZoneL === z1) {
                y100 = tempy100;
                i = 2000;
            }
        }
        const z100y = y100 * 100000;
        const out = {
            x: z100x + x,
            y: z100y + y,
            zone: z1 * 1.0
        };
        return out;
    }
    // Check if 1st letter of Square is compatible with Zone
    check_zone_vs_square100km(GZD, square100km) {
        let firstLetter = square100km.substring(0, 1);
        let zone = parseInt(GZD.substring(0, GZD.length - 1));
        let x100;
        switch (firstLetter) {
            case 'A':
                x100 = 1;
                break;
            case 'B':
                x100 = 1;
                break;
            case 'C':
                x100 = 1;
                break;
            case 'D':
                x100 = 1;
                break;
            case 'E':
                x100 = 1;
                break;
            case 'F':
                x100 = 1;
                break;
            case 'G':
                x100 = 1;
                break;
            case 'H':
                x100 = 1;
                break;
            case 'J':
                x100 = 2;
                break;
            case 'K':
                x100 = 2;
                break;
            case 'L':
                x100 = 2;
                break;
            case 'M':
                x100 = 2;
                break;
            case 'N':
                x100 = 2;
                break;
            case 'P':
                x100 = 2;
                break;
            case 'Q':
                x100 = 2;
                break;
            case 'R':
                x100 = 2;
                break;
            case 'S':
                x100 = 3;
                break;
            case 'T':
                x100 = 3;
                break;
            case 'U':
                x100 = 3;
                break;
            case 'V':
                x100 = 3;
                break;
            case 'W':
                x100 = 3;
                break;
            case 'X':
                x100 = 3;
                break;
            case 'Y':
                x100 = 3;
                break;
            case 'Z':
                x100 = 3;
                break;
        }
        let z2;
        z2 = zone - Math.floor((zone - 1) / 3) * 3;
        if (z2 === x100) {
            return true;
        }
        else {
            return false;
        }
    }
}
exports.MGRS = MGRS;



//////////////////
// WEBPACK FOOTER
// ./node_modules/gs-geo/dist/mgrs.js
// module id = 6
// module chunks = 0